import React, { useState, useEffect } from 'react';
import './toppicks.css';

import { Element } from 'react-scroll';

const API_URL = process.env.REACT_APP_API_URL;

const TopPicks = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await fetch(`${API_URL}/projectlist?sort=newest`);
        if (!response.ok) throw new Error('Failed to fetch');
        const data = await response.json();
        setProjects(data.slice(0, 4)); // Get only the first 4 projects
        setLoading(false);
      } catch (error) {
        console.error('Error fetching projects:', error);
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  const ProjectCard = ({ project }) => (
    <div className="toppicksImgContainer flip-card">
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <img src={project.image || "/api/placeholder/400/320"} alt={project.title} className="toppicksImg" />
          <div className="imgText">
            <h4 className="toppicksImgTitle">{project.title}</h4><br />
            <p className="toppicksImgDesc">{project.details}</p>
          </div>
        </div>
        <div className="flip-card-back">
          <div className="imgText2">
            <h4 className="toppicksImgTitle">{project.title}</h4><br />
            <p className="toppicksImgDesc">
              Phase: {project.phase}<br />
              Status: {project.recruiting ? 'Recruiting' : 'Not Recruiting'}<br />
            </p>
            <p className="toppicksImgDesc">{project.details}</p>
            <a href={`/project/${project.project_id}`} className="viewprojbtn">View &gt;</a>
          </div>
        </div>
      </div>
    </div>
  );

  const LoadingSkeleton = () => (
    <div className="toppicksImgContainer">
      <div className="flip-card-front">
        <div className="toppicksImg animate-pulse bg-gray-200" />
        <div className="imgText">
          <div className="h-6 w-3/4 mb-4 animate-pulse bg-gray-200 rounded" />
          <div className="h-4 w-full mb-2 animate-pulse bg-gray-200 rounded" />
          <div className="h-4 w-full mb-2 animate-pulse bg-gray-200 rounded" />
        </div>
      </div>
    </div>
  );

  return (
    <div className="toppicksParent">
    <Element name="toppicks">
      <section id="toppicks">
        <span className="toppicksTitle">Latest Projects</span>
        <span className="toppicksDescription">Check out our newest project opportunities</span>

        <div className="toppicksImgs">
          {loading ? (
            <>
              <LoadingSkeleton />
              <LoadingSkeleton />
              <LoadingSkeleton />
              <LoadingSkeleton />
            </>
          ) : (
            projects.map(project => (
              <ProjectCard key={project.project_id} project={project} />
            ))
          )}
        </div>
      </section>
    </Element>
  </div>
  );
};

export default TopPicks;